import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const DiscountPreview = ApplicationRecord.extend({
  attrs: {
    redemption: belongsTo({ type: 'vouchers-redemptions', persist: false }),
    code: belongsTo({ type: 'vouchers-codes', persist: false }),
    code_id: attr({ type: Number }),
    code_str: attr({ type: String }),
    customer_id: attr({ type: Number }),
    customer_phone: attr({ type: String }),
    customer_postcode: attr({ type: String }),
    delivery_id: attr({ type: Number }),
    discount_amount: attr({ type: Number, persist: false }),
    discounted_price: attr({ type: Number, persist: false }),
    purchase_value: attr({ type: Number }),
    redemption_id: attr({ persist: false }),
    recipe_prices: attr(),
  },
  static: {
    endpoint: '/discount_previews',
    jsonapiType: 'vouchers-discount_previews',
  },
});

export default DiscountPreview;
